export const MenuItems = [
  { title: 'About', url: '#about', cName: 'nav-links' },
  { title: 'Experience', url: '#experience', cName: 'nav-links' },
  { title: 'Projects', url: '#projects', cName: 'nav-links' },
  { title: 'Contact', url: '#contact', cName: 'nav-links' },
];
